export default __webpack_public_path__ + "static/media/img-0524-norway-full-face.c29f52c9.png";